<script>

export let level;
export let issueName;
export let content
export let topic

let showAll = false;
  function onToggle() {
    showAll = !showAll;
  }

</script>

<div class="icard {level} block slim"  class:show-more={showAll}>
    <div class="header slim">
        <h3>{topic}</h3>
        <button on:click={onToggle}>{showAll ? '-' : '+'}</button>
    </div>
        {@html content}
</div>


